@if (edito) {
    <div class="menu-edito">
        <h-media-picture-cta
            [media]="media"
            [token]="token"
            [title]="edito.title"
            (mediaRedirectionEvent)="onMediaRedirection()"
            [shouldSendDefaultRedirectionAnalytics]="false"></h-media-picture-cta>
    </div>
}
